@if (layout() === 'grid') {
  <div class="grid gap-2 md:grid-cols-2">
    @for (item of items(); track item.id) {
      @let row = rowFor(item.id);
      <div class="rounded-xl border px-3 py-1" [class]="row ? 'border-slate-300 bg-slate-50' : 'border-slate-200'">
        <mat-checkbox [checked]="!!row" [disabled]="readOnly()" (change)="toggle(item.id, $event.checked)">{{ label()(item) }}</mat-checkbox>
        @if (row && hasDetail(item)) {
          <div class="pb-1">
            <ng-container [ngTemplateOutlet]="details" [ngTemplateOutletContext]="{ item: item, row: row }" />
          </div>
        }
      </div>
    }
  </div>
} @else {
  <div class="flex flex-wrap gap-x-6 gap-y-1">
    @for (item of items(); track item.id) {
      <mat-checkbox [checked]="!!rowFor(item.id)" [disabled]="readOnly()" (change)="toggle(item.id, $event.checked)">{{ label()(item) }}</mat-checkbox>
    }
  </div>
  @for (item of tickedWithDetail(); track item.id) {
    <div class="mt-2">
      <ng-container [ngTemplateOutlet]="details" [ngTemplateOutletContext]="{ item: item, row: rowFor(item.id) }" />
    </div>
  }
}

<!-- The row's own form group is bound inside this template: a template is placed where it is used, but its fields find their form group
     where it is written. -->
<ng-template #details let-item="item" let-row="row">
  <div [formGroup]="$any(row)">
    @switch (detail()) {
      @case ('result-notes') {
        <div class="mt-1 grid gap-x-4 md:grid-cols-2">
          <mat-form-field appearance="outline" class="w-full">
            <mat-label>Result</mat-label>
            <input matInput formControlName="resultSummary" />
          </mat-form-field>
          <mat-form-field appearance="outline" class="w-full">
            <mat-label>Notes</mat-label>
            <input matInput formControlName="notes" />
          </mat-form-field>
        </div>
      }
      @case ('notes') {
        <mat-form-field appearance="outline" class="mt-1 w-full">
          <mat-label>{{ label()(item) }}: notes</mat-label>
          <input matInput formControlName="notes" />
        </mat-form-field>
      }
      @case ('other-detail') {
        <mat-form-field appearance="outline" class="mt-1 w-full">
          <mat-label>Other (specify)</mat-label>
          <input matInput formControlName="otherDetail" />
        </mat-form-field>
      }
    }
  </div>
</ng-template>
